import React, { useEffect, useState } from "react";
import PageLayout from "../components/PageLayout";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Scales, ArrowRight } from "@phosphor-icons/react";

export default function ReviewerPool() {
  const [jobs, setJobs] = useState(null);
  const [mine, setMine] = useState([]);

  const load = () => {
    api.get("/jobs?scope=review_pool").then(({ data }) => setJobs(data));
    api.get("/jobs?scope=my_reviews").then(({ data }) => setMine(data));
  };

  useEffect(() => { load(); }, []);

  const claim = async (jobId) => {
    try {
      await api.post(`/jobs/${jobId}/claim-review`);
      load();
    } catch (e) { /* ignore */ }
  };

  return (
    <PageLayout>
      <div className="max-w-6xl">
        <div className="kicker">Reviewer</div>
        <h1 className="display-serif text-4xl sm:text-5xl mt-2">Review pool.</h1>
        <p className="text-zinc-600 mt-2">Claim a review to earn on approval.</p>

        <div className="mt-8">
          <div className="kicker">Available ({jobs?.length ?? "…"})</div>
          <div className="mt-3 grid gap-3">
            {jobs === null ? <div className="text-zinc-500">Loading…</div> : jobs.length === 0 ? (
              <div className="surface-card p-8 text-zinc-600">Nothing to review right now.</div>
            ) : jobs.map(j => (
              <div key={j.job_id} data-testid={`review-pool-card-${j.job_id}`} className="surface-card p-5 flex flex-col sm:flex-row sm:items-center gap-4">
                <Scales size={22} className="text-[#115E59]" weight="duotone" />
                <div className="flex-1">
                  <div className="font-medium">{j.address}, {j.city}</div>
                  <div className="text-xs text-zinc-500 mt-0.5">{j.form_type.replace("_", " ")} • Escrow ${j.escrow_amount?.toFixed(0)}</div>
                </div>
                <button className="btn-ink" onClick={() => claim(j.job_id)} data-testid={`review-claim-${j.job_id}`}>Claim review</button>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12">
          <div className="kicker">My active reviews</div>
          <div className="mt-3 grid gap-3">
            {mine.length === 0 && <div className="surface-card p-6 text-zinc-600">Nothing claimed yet.</div>}
            {mine.filter(j => j.status === "in_review").map(j => (
              <Link key={j.job_id} to={`/reviews/${j.job_id}`} className="surface-card p-5 flex items-center gap-4 hover:-translate-y-0.5 transition-transform" data-testid={`review-mine-${j.job_id}`}>
                <div className="flex-1">
                  <div className="font-medium">{j.address}, {j.city}</div>
                  <div className="text-xs text-zinc-500 mt-0.5">Escrow ${j.escrow_amount?.toFixed(0)}</div>
                </div>
                <ArrowRight size={16} className="text-zinc-400" />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
